
import { Component, Mixins } from 'vue-property-decorator';
import Page from '@/views/Page.vue'
import { AthleteTeamDashboard, AthleteTeamJoin } from '@/../types/constants/web_client_user.routes';
import { MyAthleteMixin, StringsMixin, SportsSelectorMixin, BAIconsMixin, VuetifyMixin } from '@/mixins';
import { TeamModel, PlayerOnTeam, AthleteTeam } from '@/models/team';
import TeamMiniCard from '@/components/ui/TeamMiniCard.vue';
import JerseyEditColor from '@/components/teams/JerseyEditColor.vue';
import { athleteApi } from '@/api/AthleteApi';
import { teamApi } from '@/api/TeamApi';

@Component({
	components:{
		Page,
        TeamMiniCard,
		JerseyEditColor,
	},
})
export default class AthleteTeamsSummary extends Mixins(VuetifyMixin, StringsMixin, MyAthleteMixin, SportsSelectorMixin, BAIconsMixin) {
    get Loading(): boolean{
		return this.IsAthleteLoading || this.UpdatingAthlete;
	}

	viewTeam(team: TeamModel) {
		if( this.IsEmpty(team?.id) ) return;

		this.$router.push({
			name: AthleteTeamDashboard,
			params: {
				teamId: team.id,
			}
		});
	}
	joinTeam() {
		this.$router.push({
			name: AthleteTeamJoin,
			params:{
				athleteId: this.TheAthleteId,
			}
		});
	}

    editTeam: TeamModel;
    editPlayer: PlayerOnTeam;
    backupPlayer: PlayerOnTeam;
    editingTeamPlayer: boolean = false;
    async setCurrentTeam(team: TeamModel) {
		if( this.IsEmpty(team) ) return;
		if( this.IsNotEmpty(team.id) && this.athleteProfile.currentTeam === team.id ) return;
		if( this.athleteProfile.currentTeam === team.name ) return;

        this.updatingTeams = true;
		if( this.IsNotEmpty(team.id) ) this.athleteProfile.currentTeam = team.id;
		else this.athleteProfile.currentTeam = team.name;

		this.athleteProfile.loadTeams(undefined, true);
        await athleteApi.save(this.athleteProfile);
        this.updatingTeams = false;
    }
    async setInjuredStatus(isInjured: boolean) {
        for( const team of this.TheAthleteProfile.teams ) {
            const athlete = team.players.find(p => p.athleteId === this.TheAthleteId );
            if( this.IsNotEmpty(athlete) ) {
				athlete.injured = isInjured;
            	teamApi.patchPlayer({teamId: team.id, playerId: athlete.id, playerPatch: athlete});
			}
        }
    }
	async setEligibleStatus(teamId: string, isEligible: boolean) {
		const team = this.TheAthleteProfile.teams.find(t => t.id === teamId);
		if( this.IsEmpty(team) ) return;
		const athlete = team.players.find(p => p.athleteId === this.TheAthleteId );
		if( this.IsNotEmpty(athlete) ) {
			athlete.eligibleToPlay = isEligible;
			teamApi.patchPlayer({teamId: team.id, playerId: athlete.id, playerPatch: athlete});
		}
	}
	async editAthleteOnAthleteTeam(team: TeamModel) {
		await athleteApi.patch({ id: this.athleteProfile.id, athleteTeams: this.athleteProfile.athleteTeams});
	}
    async editAthleteOnTeam(teamId: string) {
        if( !this.TheAthleteProfile.HasTeam ) return;

        const team = this.TheAthleteProfile.teams.find(t => t.id === teamId);
        if( this.IsEmpty(team) ) return;

        this.editTeam = team;
		this.editPlayer = team.players.find(p => p.athleteId === this.TheAthleteId);
        if( this.IsEmpty(this.editPlayer) ) return;

        this.backupPlayer = Object.assign({}, this.editPlayer);
        this.editingTeamPlayer = true;
    }
	async onCancelEditPlayer() {
		Object.assign(this.editPlayer, this.backupPlayer);
		this.editingTeamPlayer = false;
	}
	async onAcceptEditPlayer() {
		this.editingTeamPlayer = false;
		this.editPlayer = undefined;
	}

	isAddingAthleteTeam: boolean = false;
	isAddingAthleteTeamChanged: boolean = false;
	newAthleteTeamLogoUrl: string = "";
	newAthleteTeam: AthleteTeam;
	async onAthleteTeamCreate() {
		this.newAthleteTeam = new AthleteTeam();
		const playerOnPrevTeam = this.athleteProfile.CurrentTeam.players.find(p => p.athleteId === this.TheAthleteId);
		const player = this.IsEmpty(playerOnPrevTeam)?
			{
				id: undefined,
				userId: undefined,
				athleteId: this.TheAthleteId,
				number: '12',
			} : {...playerOnPrevTeam, id: undefined };
		this.newAthleteTeam.players.push(player);
		this.newAthleteTeamLogoUrl = this.newAthleteTeam.logoUrl;
		this.isAddingAthleteTeamChanged = false;
		this.isAddingAthleteTeam = true;
	}
	async onAthleteTeamCreateCancel() {
		this.newAthleteTeam = undefined;
		this.isAddingAthleteTeamChanged = false;
		this.isAddingAthleteTeam = false;
	}
	async onAthleteTeamCreateOK() {
		if( this.IsEmpty(this.athleteProfile.athleteTeams) ) this.athleteProfile.athleteTeams = [];
		this.athleteProfile.athleteTeams.push(this.newAthleteTeam);
		await athleteApi.save(this.athleteProfile);
		this.isAddingAthleteTeam = false;
	}
	async onNewTeamChanged() {
		this.isAddingAthleteTeamChanged = this.IsNotEmpty(this.newAthleteTeam.name);
	}
	async onNewTeamLogoUrlChanged() {
		this.newAthleteTeam.logoUrl = this.newAthleteTeamLogoUrl;
		await this.onNewTeamChanged();
	}

	isViewingAthleteTeam: boolean = false;
	async viewAthleteTeam(team: TeamModel) {
		this.athleteTeam = new AthleteTeam();
		this.athleteTeam.fromTeamModel(team);
		this.isViewingAthleteTeam = true;
		this.editAthleteTeam(this.athleteTeam);
	}

	isEditingAthleteTeam: boolean = false;
	isEditAthleteTeamChanged: boolean = false;
	athleteTeamEditLogoUrl: string;
	athleteTeam: AthleteTeam;
	async editAthleteTeam(team: AthleteTeam) {
		this.isEditAthleteTeamChanged = true;
		this.athleteTeam = team;
		this.athleteTeamEditLogoUrl = this.athleteTeam.logoUrl;
		this.isEditingAthleteTeam = true;
	}
	async onAthleteTeamEditCancel() {
		this.isViewingAthleteTeam = false;
		this.isEditingAthleteTeam = false;
	}
	async onAthleteTeamEditOK() {
		await athleteApi.patch({ id: this.athleteProfile.id, athleteTeams: this.athleteProfile.athleteTeams});
		this.isViewingAthleteTeam = false;
		this.isEditingAthleteTeam = false;
	}
	async onAthleteTeamEditChanged() {
		this.isEditingAthleteTeam = this.IsNotEmpty(this.athleteTeam.name);
	}
	async onAthleteTeamEditLogoUrlChanged() {
		this.athleteTeam.logoUrl = this.athleteTeamEditLogoUrl;
		await this.onAthleteTeamEditChanged();
	}

}

